import { render, staticRenderFns } from "./RecommendThird.vue?vue&type=template&id=62b7022b&scoped=true"
import script from "./RecommendThird.vue?vue&type=script&lang=js"
export * from "./RecommendThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7022b",
  null
  
)

export default component.exports